var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgKassa = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 13,
  fill: "none",
  viewBox: "0 0 13 13"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#7F7F7F",
  fillRule: "evenodd",
  clipRule: "evenodd",
  opacity: 0.7
}, /*#__PURE__*/React.createElement("path", {
  d: "m3.355 11.39 1.448 1.449c.11.11.248.161.41.161a.54.54 0 0 0 .387-.161l7.24-7.244a.55.55 0 0 0 0-.775l-1.412-1.412a.55.55 0 0 0-.775 0 .735.735 0 0 1-1.039-1.04.56.56 0 0 0-.007-.775L8.174.16a.55.55 0 0 0-.775 0L.159 7.403a.55.55 0 0 0 0 .775l1.397 1.398a.54.54 0 0 0 .76.014.724.724 0 0 1 1.017.015.73.73 0 0 1 .014 1.017.55.55 0 0 0 .008.768m5.56-7.283c.563.564 1.42.659 2.081.283l.817.818L5.2 11.823l-.867-.867a1.74 1.74 0 0 0-.285-2.049c-.56-.56-1.4-.669-2.057-.31l-.807-.806 6.601-6.605.841.841a1.74 1.74 0 0 0 .287 2.08"
}), /*#__PURE__*/React.createElement("path", {
  d: "m2.79 5.847 4.263 4.229.523-.516-4.262-4.228z"
}))));
export default SvgKassa;